import { Box, Divider } from "@mui/material";
import Addresses from "./components/addresses";
import CreatorLink from "./components/creatorLink";
import CopyRights from "./components/copyright";
import FooterNavigation from "./components/footerNavigation";
import PhoneContact from "./components/phoneContact";
import { MobileContacts } from "../contact";
import Gene20Box from "../Gene20Box/Gene20Box";

function Footer() {
  return (
    <Gene20Box
      width="100%"
      display={{ xs: "flex", lg: "block" }}
      justifyContent="space-between"
      alignItems="center"
      px={1.5}
      sx={{ background: "#00000077" }}
    >
      <Gene20Box>
        <Box
          display={{ xs: "block", sm: "flex" }}
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          px={1.5}
          marginTop="1rem"
          sx={{ fontSize: (theme) => theme.typography.size.sm }}
        >
          <MobileContacts />
          <FooterNavigation />
        </Box>
        <Divider />
        <Box
          display={{ xs: "block", sm: "flex" }}
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          // px={1.5}
          sx={{ fontSize: (theme) => theme.typography.size.sm }}
        >
          <Addresses />
          <PhoneContact />
        </Box>

        <Box>
          <Divider />
          <Gene20Box
            sx={{ display: { xs: "block", sm: "flex" } }}
            justifyContent="space-evenly"
            alignItems="center"
            margin="1rem 0 1rem"
            px={1.5}
          >
            <CreatorLink />
            <CopyRights />
          </Gene20Box>
        </Box>
      </Gene20Box>
    </Gene20Box>
  );
}

export default Footer;
